'use strict';
(function($) {
	$.fn.swipeTable = function() {
		return this.each(function() {
			var $self = $(this);

			var wrapper, table, leftNav, rightNav;

			function init() {

				leftNav  = $('<div class="swipe-table-left-nav">');
				rightNav = $('<div class="swipe-table-right-nav">');

				$self.wrap('<div class="swipe-table-outer-wrapper"></div>');

				$self.startPosX = false;
				$self.css({
					'overflow-x': 'hidden'
				});

				wrapper = $self.closest('.swipe-table-outer-wrapper');
				table   = $self.find('table');

				wrapper.css({
					'overflow-x': 'hidden',
					'position'  : 'relative'
				});

				wrapper.prepend(leftNav);
				wrapper.append(rightNav);

				$self.trigger('tapmove');

			}

			function showNavs() {

				var scrollLeft = $self.scrollLeft();

				if(scrollLeft === 0) {
					leftNav.stop(true).animate({
						opacity: 0,
					}, function() {
						leftNav.hide(); // hide so the element doesn't cover column of table, will stop buttons from being clicked
					});
				} else {
					leftNav.stop(true).show().animate({
						opacity: 1,
					});
				}

				if(scrollLeft >= table.width() - $self.width()) {
					rightNav.stop(true).animate({
						opacity: 0,
					}, function() {
						rightNav.hide(); // hide so the element doesn't cover column of table, will stop buttons from being clicked
					});
				} else {
					rightNav.stop(true).show().animate({
						opacity: 1,
					});
				}

			}

			function onTapstart(e, touch) {

				$self.startPosX = $self.scrollLeft() + touch.position.x;
			}

			function onTapmove(e, touch) {

				if($self.startPosX !== false) {
					$self.scrollLeft($self.startPosX - touch.position.x);

				}
			}

			function onTapend() {
				$self.startPosX = false;
			}

			function onMouseleave() {
				$self.trigger('tapend');
			}

			function cursor(e) {
				// e.preventDefault(); // This was causing the user not to be able to scroll the page on touch devices when touching this table.
				$self.toggleClass('grab', e.currentTarget.offsetWidth < e.currentTarget.scrollWidth);
			}


			$self.on('tapstart', onTapstart);
			$self.on('tapmove', onTapmove);
			$self.on('tapmove', _.debounce(showNavs, 250));
			$self.on('tapend', onTapend);
			$self.on('mouseleave', onMouseleave);
			$self.on('tapstart tapmove tapend mouseleave', cursor);

			init();
		});
	};
}(jQuery));